import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Home } from "lucide-react";

const stateName = import.meta.env.VITE_STATE_NAME || "";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="container-custom py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <Home size={28} className="text-primary" />
            <span className="text-xl font-heading font-bold text-primary">
              {stateName} Mortgage Tools
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`font-medium transition-colors ${
                isActive("/")
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Home
            </Link>
            <Link
              to="/check-my-rate"
              className={`font-medium transition-colors ${
                isActive("/check-my-rate")
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Rate My Quote
            </Link>
            <Link
              to="/quote-start"
              className={`font-medium transition-colors ${
                isActive("/quote-start")
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Shop Rates
            </Link>
            <Link
              to="/should-i-refinance"
              className={`font-medium transition-colors ${
                isActive("/should-i-refinance")
                  ? "text-primary border-b-2 border-primary pb-1"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Refi Buddy
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 space-y-4">
            <Link
              to="/"
              className={`block font-medium transition-colors ${
                isActive("/")
                  ? "text-primary"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Home
            </Link>
            <Link
              to="/check-my-rate"
              className={`block font-medium transition-colors ${
                isActive("/check-my-rate")
                  ? "text-primary"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Rate My Quote
            </Link>
            <Link
              to="/quote-start"
              className={`block font-medium transition-colors ${
                isActive("/quote-start")
                  ? "text-primary"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Shop Rates
            </Link>
            <Link
              to="/should-i-refinance"
              className={`block font-medium transition-colors ${
                isActive("/should-i-refinance")
                  ? "text-primary"
                  : "text-gray-600 hover:text-primary"
              }`}
            >
              Refi Buddy
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
